import React from 'react'
import Button from 'components/atoms/Button/Button'
import Modal from 'components/molecules/Modal/Modal'
import styles from './DeleteSegmentConfirmation.module.scss'

interface DeleteSegmentConfirmationProps {
  isOpen?: boolean
  segmentName?: string
  onConfirm: () => void
  onCancel: () => void
}

const DeleteSegmentConfirmation = ({
  isOpen = false,
  segmentName,
  onConfirm,
  onCancel,
}: DeleteSegmentConfirmationProps): React.ReactElement => {
  return (
    <Modal className={styles.root} showClose={false} isOpen={isOpen} theme="dark">
      <h3 className="Modal_Title">Confirm delete</h3>
      <div className="Modal_Content">
        <p>Are you sure you want to delete {segmentName} segment?</p>
      </div>
      <div className="Modal_Actions">
        <Button className={styles['delete-button']} link onClick={onConfirm}>
          Yes, delete
        </Button>
        <Button link onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </Modal>
  )
}

export default DeleteSegmentConfirmation
